import { display } from '../tools/display';
import { matchList } from '../tools/matchOption';
import { isUnsupportedExtensionEnvironment } from './extension/extensionUtils';
export var ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN = 'Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.';
export var ERROR_NOT_ALLOWED_TRACKING_ORIGIN = 'SDK initialized on a non-allowed domain.';
export function isAllowedTrackingOrigins(configuration, errorStack) {
  var windowOrigin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : typeof location !== 'undefined' ? location.origin : '';
  var allowedTrackingOrigins = configuration.allowedTrackingOrigins;

  if (!allowedTrackingOrigins) {
    if (isUnsupportedExtensionEnvironment(windowOrigin, errorStack)) {
      display.error(ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN);
      return false;
    }

    return true;
  }

  var isAllowed = matchList(allowedTrackingOrigins, windowOrigin);

  if (!isAllowed) {
    display.error(ERROR_NOT_ALLOWED_TRACKING_ORIGIN);
  }

  return isAllowed;
}